module.exports = __webpack_public_path__ + "img/complete.8973f72d.png";